export default "__VITE_ASSET__VQDrUAdJ__"